import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import React, { Fragment } from 'react';
import { timeSince } from '@finect/front-utils/timeSince';
import { shortMonths, longMonths, weekdays } from '../../commons/locales/es_ES';
var withZero = function withZero(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return number.toString().padStart(length, '0');
};
export var formatter = function formatter(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  var month = date.getMonth();
  var year = date.getFullYear();
  var day = date.getDate();
  var minute = date.getMinutes();
  var hour = date.getHours();
  if (format === 'timeSince') {
    return timeSince(date);
  }
  if (format === 'L') {
    return "".concat(day, "/").concat((month + 1).toString().padStart(2, '0'), "/").concat(year);
  }
  if (format === 'LS') {
    return "".concat(day, "/").concat((month + 1).toString().padStart(2, '0'), "/").concat(year, " ").concat(withZero(hour), ":").concat(withZero(minute), "h");
  }
  if (format === 'll') {
    return "".concat(day, "-").concat(shortMonths[month], "-").concat(year);
  }
  if (format === 'LL') {
    return "".concat(day, " ").concat(longMonths[month].toLowerCase(), " ").concat(year);
  }
  if (format === 'LLL') {
    return "".concat(day, " de ").concat(longMonths[month].toLowerCase(), " de ").concat(year);
  }
  if (format === 'LLS') {
    return "".concat(day, " ").concat(shortMonths[month].toLowerCase(), " a las ").concat(withZero(hour), ":").concat(withZero(minute), "h");
  }
  if (format === 'LLLS') {
    return "".concat(day, " ").concat(shortMonths[month].toLowerCase(), " de ").concat(year, ", a las ").concat(withZero(hour), ":").concat(withZero(minute), "h");
  }
  if (format === 'lll') {
    return "".concat(day, " ").concat(longMonths[month]);
  }
  if (format === 'MMMM') {
    return longMonths[month];
  }
  if (format === 'YYYY') {
    return year;
  }
  if (format === 'calendar') {
    return React.createElement(Fragment, null, React.createElement("span", null, day), " ", weekdays[date.getDay()]);
  }
  return "".concat(day, "/").concat((month + 1).toString().padStart(2, '0'), "/").concat(year);
};